import { Align } from './types'

export const icons: Map<Align, string> = new Map([
  [
    Align.LEFT,
    `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M4 4H16V5.33333H4V4ZM4 6.66667H12V8H4V6.66667ZM4 9.33333H16V10.6667H4V9.33333ZM4 12H12V13.3333H4V12ZM4 14.6667H16V16H4V14.6667Z"/>
        </svg>
    `,
  ],
  [
    Align.CENTER,
    `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="m4,4l12,0l0,1.33333l-12,0l0,-1.33333zm2.66667,2.66667l6.66663,0l0,1.33333l-6.66663,0l0,-1.33333zm-2.66667,2.66666l12,0l0,1.33334l-12,0l0,-1.33334zm2.66667,2.66667l6.66663,0l0,1.3333l-6.66663,0l0,-1.3333zm-2.66667,2.6667l12,0l0,1.3333l-12,0l0,-1.3333z"/>
        </svg>
    `,
  ],
  [
    Align.RIGHT,
    `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="m4,4l12,0l0,1.33333l-12,0l0,-1.33333zm4,2.66667l8,0l0,1.33333l-8,0l0,-1.33333zm-4,2.66666l12,0l0,1.33334l-12,0l0,-1.33334zm4,2.66667l8,0l0,1.3333l-8,0l0,-1.3333zm-4,2.6667l12,0l0,1.3333l-12,0l0,-1.3333z"/>
        </svg>
    `,
  ],
])
